<form [formGroup]="quizForm">
  <div class="modal-overlay">
    <div class="quiz-modal">
      <div class="qm-header">
        <div>
          <div class="qm-title">
            <i class="bi bi-card-text me-1"></i>Edit Quiz
          </div>
          <div class="qm-sub">
            Configure quiz details, audience and proctoring before adding
            questions
          </div>
        </div>
        <span class="close" (click)="closeDialog()">
          <i class="bi bi-x-lg"></i>
        </span>
      </div>

      <div class="qm-body">
        <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">1</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-card-text me-2"></i>
                Quiz details
              </div>
              <div class="sec-sub">
                Give your quiz a clear name and description
              </div>
            </div>
          </div>

          <div class="qm-content">
            <div class="field-group">
              <label class="field-label"
                >Quiz Title
                <span class="req">*</span>
              </label>
              <input
                formControlName="quiz_name"
                placeholder="e.g Placement KickStart Quiz"
              />
            </div>

            <!-- <div class="field-group">
            <div class="label-row">
              <label class="field-label">Quiz Description</label>
              <span class="optional">Optional</span>
            </div>
            <textarea formControlName="description"
              placeholder="Briefly describe what this quiz covers..."
            ></textarea>
          </div> -->
          </div>
        </div>

        <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">2</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-sliders me-2"></i>
                Configuration
              </div>
              <div class="sec-sub">
                Control how students experience the quiz
              </div>
            </div>
          </div>

          <div class="qm-content grid-2">
            <div class="field-group">
              <label class="field-label"
                >Duration
                <span class="req">*</span>
              </label>

              <div class="time-input">
                <input
                  type="text"
                  formControlName="hh"
                  placeholder="HH"
                  maxlength="2"
                  (input)="handleTimeInput($event, 23)"
                />
                <span>:</span>

                <input
                  type="text"
                  formControlName="mm"
                  placeholder="MM"
                  maxlength="59"
                  (input)="handleTimeInput($event, 59)"
                />
                <span>:</span>

                <input
                  type="text"
                  formControlName="ss"
                  placeholder="SS"
                  maxlength="59"
                  (input)="handleTimeInput($event, 59)"
                />
              </div>
            </div>

            <div class="field-group">
              <label class="field-label">Attempts Allowed</label>
              <input
                formControlName="attempts_allowed"
                placeholder="e.g. 3"
                type="number"
              />
            </div>

            <div class="field-group">
              <label class="field-label">Passing Score (%)</label>
              <input
                formControlName="passing_score"
                placeholder="e.g. 60%"
                type="number"
              />
            </div>

            <div class="field-group">
              <div class="label-row">
                <label class="field-label">No. of Questions per User</label>
                <span class="serve">Served per attempt</span>
              </div>
              <input
                formControlName="questions_per_quiz"
                placeholder="e.g. 10"
                type="number"
              />
            </div>
          </div>

          <div class="divider"></div>

          <div class="toggle-row">
            <div class="toggle-text">
              <span class="title">Shuffle questions</span>
              <p class="desc">
                Randomize the order of questions for each attempt
              </p>
            </div>
            <label class="switch">
              <input type="checkbox" formControlName="shuffle_questions" />
              <span class="slider"></span>
            </label>
          </div>

          <div class="toggle-row">
            <div class="toggle-text">
              <span class="title">Shuffle options</span>
              <p class="desc">Randomize the order of answer now</p>
            </div>
            <label class="switch">
              <input type="checkbox" formControlName="shuffle_options" />
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <!-- <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">3</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-people me-2"></i>Quiz mode
              </div>
              <div class="sec-sub">Choose who will take this quiz</div>
            </div>
          </div>

          <label class="field-label">Select mode *</label>

          <div class="mode-row">
            <label class="mode-card" [class.active]="mode === 'course'">
              <input
                type="radio"
                name="mode"
                value="course"
                formControlName="mode"
              />

              <div class="mode-text">
                <div class="mode-title">Publish to Course</div>
                <div class="mode-desc">
                  Assign to everyone enrolled in a course
                </div>
              </div>
            </label>

            <label class="mode-card" [class.active]="mode === 'group'">
              <input
                type="radio"
                name="mode"
                value="group"
                formControlName="mode"
              />

              <div class="mode-text">
                <div class="mode-title">Independent Quiz</div>
                <div class="mode-desc">Assign to selected user groups</div>
              </div>
            </label>
          </div>

          <div *ngIf="mode === 'course'">
            <label class="field-label"
              >Select course <span class="req">*</span>
            </label>
            <select class="dropdown" formControlName="course_id">
              <option value="">Choose a course...</option>
              <option *ngFor="let course of courses" [value]="course.id">
                {{ course.name }}
              </option>
            </select>

            <div class="info-box">
              <i class="bi bi-info-circle me-2"></i>
              This quiz will be automatically assigned to all students enrolled
              in the selected course.
            </div>
          </div>

          <div *ngIf="mode === 'group'">
            <label class="field-label">Select user group *</label>

            <div class="custom-dropdown" (click)="toggleGroupDropdown()">
              <div class="dropdown-display">
                {{
                  selectedGroups.length
                    ? selectedGroups.join(", ")
                    : "Choose a user group..."
                }}
              </div>

              <div class="arrow">&#9662;</div>
              <div
                class="dropdown-list"
                *ngIf="isGroupDropdownOpen"
                (click)="$event.stopPropagation()"
              >
                <label
                  class="dropdown-item"
                  *ngFor="let group of userGroups"
                  [class.selected]="selectedGroups.includes(group)"
                >
                  <input
                    type="checkbox"
                    [checked]="selectedGroups.includes(group)"
                    (change)="onSelectGroup(group)"
                  />
                  {{ group }}
                </label>
              </div>
            </div>
          </div>
        </div> -->    
      <div class="qm-section">
        <div class="qm-sec-head">
          <div class="step">3</div>
          <div>
            <div class="sec-title">
              <i class="bi bi-shield-check me-2"></i>
              Proctoring
            </div>
            <div class="sec-sub">
              Enable monitoring to maintain quiz integrity
            </div>
          </div>
        </div>

        <div class="toggle-row">
          <div>
            <div class="field-title">Enable proctoring</div>
            <div class="sec-sub">
              {{
                quizForm.get('isProctored')?.value
                  ? "Proctored — monitoring features are active"
                  : "Non-proctored - no monitoring applied"
              }}
            </div>
          </div>

          <label class="switch">
            <input type="checkbox" formControlName="isProctored" />
            <span class="slider"></span>
          </label>
        </div>

        <div *ngIf="quizForm.get('isProctored')?.value" class="proctor-options">
          <label *ngFor="let option of proctorOptions" class="proctor-item">
            <input
              type="checkbox"
              [checked]="selectedOptions.includes(option)"
              (change)="toggleOption(option)"
            />
            <span>{{ option }}</span>
          </label>
        </div>
      </div>

        <!-- <div class="qm-section">
        <div class="qm-sec-head">
          <div class="step">4</div>
          <div>
            <div class="sec-title">
              <i class="bi bi-calendar me-2"></i>Schedule
            </div>
            <div class="sec-sub">
              Optionally limit when this quiz is available
            </div>
          </div>
        </div>

        <div class="grid-2">
          <div>
            <label class="field-label">
              Start date & time <span class="optional">Optional</span>
            </label>

            <div class="input-wrapper">
              <input type="datetime-local" class="input" />
            </div>
          </div>

          <div>
            <label class="field-label">
              End date & time <span class="optional">Optional</span>
            </label>

            <div class="input-wrapper">
              <input type="datetime-local" class="input" />
            </div>
          </div>
        </div>

        <div class="mt-12">
          <label class="field-label">Time zone</label>
          <select class="dropdown">
            <option>IST (UTC+05:30)</option>
          </select>
        </div>
      </div> -->
      </div>

      <div class="qm-footer">
        <button class="btn-cancel w-25" type="button" (click)="closeDialog()">
          Cancel
        </button>
        <button class="btn-primary w-25" type="button" (click)="saveQuiz()">
          Save
        </button>
      </div>
    </div>
  </div>
</form>
